module.exports = __webpack_public_path__ + "static/favicon-33d8ec492878f13d7a71a27373e389f6.png";